import {gql} from '@apollo/client';

export const GET_PICKUP_POINT_OPTIONS = gql`
  query GetPickupPointOptions($input: PickupPointOptionsInput!) {
    getPickupPointOptions(input: $input) {
      hubList {
        id
        name
        type
        value
        fullAddress
        phone
      }
      rallyPointList {
        id
        name
        type
        value
        fullAddress
        phone
      }
      firstAppointmentAddress {
        id
        name
        type
        value
        fullAddress
        phone
      }
      warehouseList {
        id
        name
        type
        value
        fullAddress
        phone
      }
    }
  }
`;

export interface PickupPointOption {
    id: string;
    name: string;
    type: 'HUB' | 'RALLY_POINT' | 'FIRST_APPOINTMENT' | 'WAREHOUSE';
    value: string;
    fullAddress?: string;
    phone?: string;
}

export interface PickupPointOptionsData {
    hubList: PickupPointOption[];
    rallyPointList: PickupPointOption[];
    firstAppointmentAddress?: PickupPointOption;
    warehouseList: PickupPointOption[];
}

export interface PickupPointOptionsInput {
    warehouseId: string;
    taskId?: string;
}

export interface GetPickupPointOptionsResponse {
    getPickupPointOptions: PickupPointOptionsData;
}